<template>
	<section class="main-content intro">
		<div class="row">
			<slot>
				<div class="columns column6 align-left">
					<div class="reverse-header">
						<h1>{{ title }}</h1>
						<h2 class="subtitle">{{ subtitle }}</h2>
					</div>
					<slot name="extra-heading" />
				</div>
				<div class="columns column6 align-left">
					<div v-parse-links v-html="content" />
					<slot name="extra-content" />
				</div>
			</slot>
		</div>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.reverse-header {
	display: flex;
	flex-flow: column-reverse;
	justify-content: flex-start;
}
</style>
